<template>
  <v-layout align-center>
    <v-select
      v-model="addedItem"
      :items="options"
      :label="label"
      class="mr-5"
    />

    <v-btn
      small
      color="success"
      :loading="loading"
      :disabled="!addedItem"
      @click="$emit('add')"
    >
      Add
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  name: 'DependencyAdder',

  model: {
    type: 'input',
    prop: 'value',
  },

  props: {
    value: {
      type: String,
      required: true,
    },

    loading: {
      type: Boolean,
      required: true,
    },

    label: {
      type: String,
      required: true,
    },

    options: {
      type: Array,
      required: true,
    },
  },

  computed: {
    addedItem: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
};
</script>
